import axios from "axios";
import { API, SERVER_URL } from '../constants/api';
import cookieStorage from "../services/cookie-storage";
import HttpService from "../services/http-service";
import { serialize } from "./../constants/function";
const config = {
  headers: {
    Authorization: "",
  },
};
export const header = {
  headers: {
    Authorization: cookieStorage.getCookie("Authorization"),
    
    // "Content-Type": "application/json",
    // "Access-Control-Allow-Origin": "*",
  },
};
export default class ApiService {
  static async getToken(tempToken) {
    const token = tempToken
      ? tempToken
      : cookieStorage.getCookie("Authorization");

    config.headers.Authorization = token;
    config.headers["Content-Type"] = "application/json";
    config.withCredentials = true;

    // config.headers["Access-Control-Allow-Origin"] = "*";
  }
 // Admin: Feature/Unfeature Artist
static async ADMIN_FEATURE_ARTIST(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_FEATURE_ARTIST, payload, config);
}
static async ADMIN_UNFEATURE_ARTIST(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_UNFEATURE_ARTIST, payload, config);
}

// Admin: Feature/Unfeature Music
static async ADMIN_FEATURE_MUSIC(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_FEATURE_MUSIC, payload, config);
}
static async ADMIN_UNFEATURE_MUSIC(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_UNFEATURE_MUSIC, payload, config);
}

// Admin: Feature/Unfeature Video
static async ADMIN_FEATURE_VIDEO(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_FEATURE_VIDEO, payload, config);
}
static async ADMIN_UNFEATURE_VIDEO(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_UNFEATURE_VIDEO, payload, config);
}

// Admin: Feature/Unfeature Playlist
static async ADMIN_FEATURE_PLAYLIST(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_FEATURE_PLAYLIST, payload, config);
}
static async ADMIN_UNFEATURE_PLAYLIST(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_UNFEATURE_PLAYLIST, payload, config);
}

static async ADMIN_REMOVE_FEATURED_PLAYLIST(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_UNFEATURE_PLAYLIST, payload, config);
}

static async ADMIN_GET_ALL_USERS(keywords) {
  const params = serialize(keywords); // Serialize the keywords into a query string
  await this.getToken(); // Ensure the token is set
  const requestUrl = `${API.ADMIN_GET_ALL_USERS}${params}`; // Construct the full URL
  console.log("Request URL:", requestUrl); // Debugging log
  return HttpService.get(requestUrl, config); // Make the GET request
}

static async ADMIN_END_LIVESTREAM(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_END_LIVESTREAM, payload, config);
}

// Admin: Get a user's streaming balance
static async ADMIN_GET_USER_STREAMING_BALANCE(userId) {
  await this.getToken();
  // userId as query param
  return HttpService.get(`${API.ADMIN_USER_STREAMING_BALANCE}?userId=${userId}`, config);
}

// Admin: Add to a user's streaming balance
static async ADMIN_ADD_USER_STREAMING_BALANCE(payload) {
  await this.getToken();
  // payload: { userId, amount }
  return HttpService.post(API.ADMIN_USER_STREAMING_BALANCE, payload, config);
}

static async ADMIN_VERIFY_USER(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_VERIFY_ARTIST, payload, config);
}

// Admin: Freeze user
static async ADMIN_FREEZE_USER(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_FREEZE_USERS, payload, config);
}

// Admin: Get user balance
static async ADMIN_GET_USER_BALANCE(userId) {
  await this.getToken();
  return HttpService.get(`${API.ADMIN_BALANCE}?userId=${userId}`, config);
}

// Admin: Update user profile
static async ADMIN_UPDATE_USER_PROFILE(userId, formData) {
  await this.getToken();
  config.headers["Content-Type"] = "multipart/form-data";
  return HttpService.post(`${API.ADMIN_USER}/${userId}/profile`, formData, config);
}

// Admin: Upload music for user
static async ADMIN_UPLOAD_MUSIC_FOR_USER(userId, formData) {
  await this.getToken();
  config.headers["Content-Type"] = "multipart/form-data";
  return HttpService.post(`${API.ADMIN_USER}/${userId}/music`, formData, config);
}

// Admin: Upload video for user
static async ADMIN_UPLOAD_VIDEO_FOR_USER(userId, formData) {
  await this.getToken();
  config.headers["Content-Type"] = "multipart/form-data";
  return HttpService.post(`${API.ADMIN_USER}/${userId}/video`, formData, config);
}

// Admin: Create studio for user
static async ADMIN_CREATE_STUDIO_FOR_USER(userId, formData) {
  await this.getToken();
  config.headers["Content-Type"] = "multipart/form-data";
  return HttpService.post(`${API.ADMIN_USER}/${userId}/studio`, formData, config);
}

// Admin: Get user content stats
static async ADMIN_GET_USER_STATS(userId) {
  await this.getToken();
  return HttpService.get(`${API.ADMIN_USER}/${userId}/stats`, config);
}

// Admin: Get user content lists
static async ADMIN_GET_USER_CONTENT(userId, contentType = 'all', page = 1, limit = 20) {
  await this.getToken();
  const params = new URLSearchParams({ contentType, page: page.toString(), limit: limit.toString() });
  return HttpService.get(`${API.ADMIN_USER_CONTENT}/${userId}/content?${params.toString()}`, config);
}

// Admin: Delete user content
static async ADMIN_DELETE_USER_CONTENT(userId, contentType, contentId) {
  await this.getToken();
  return HttpService.delete(`${API.ADMIN_USER}/${userId}/${contentType}/${contentId}`, config);
}

// Admin: Role management (only chris@siki.io can access)
static async ADMIN_MANAGE_ROLE(payload) {
  await this.getToken();
  return HttpService.post(API.ADMIN_MANAGE_ROLE, payload, config);
}

static async ADMIN_GET_ADMIN_USERS() {
  await this.getToken();
  return HttpService.get(API.ADMIN_GET_ADMIN_USERS, config);
}

// Admin: Search artists
static async ADMIN_SEARCH_ARTIST(params) {
  await this.getToken();
  const queryString = params.query ? `?keyword=${encodeURIComponent(params.query)}` : '';
  return HttpService.get(`${API.ADMIN_SEARCH_ARTIST}${queryString}`, config);
}

// Admin: Get all playlists
static async ADMIN_GET_ALL_PLAYLISTS(params = {}) {
  await this.getToken();
  const queryString = params.query ? `?query=${encodeURIComponent(params.query)}` : '';
  return HttpService.get(`${API.ADMIN_GET_ALL_PLAYLISTS}${queryString}`, config);
}

// Admin: Get user stream transactions
static async ADMIN_GET_USER_STREAM_TRANSACTIONS(params) {
  await this.getToken();
  const queryString = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_USER_STREAM_TRANSACTIONS}?${queryString}`, config);
}

// Admin: Get user stream transaction summary
static async ADMIN_GET_USER_STREAM_SUMMARY(params) {
  await this.getToken();
  const queryString = new URLSearchParams(params).toString();
  return HttpService.get(`${API.ADMIN_USER_STREAM_TRANSACTIONS_SUMMARY}?${queryString}`, config);
}

// Admin: Search users
static async ADMIN_SEARCH_USER(query) {
  await this.getToken();
  // Use the general user search endpoint which works better
  return HttpService.get(`${API.SEARCH_USER}${encodeURIComponent(query)}`, config);
}


  //Auth
  static async googleSignInWithToken(payload) {
    // Add redirect URI to payload based on current environment
    const enhancedPayload = {
      ...payload,
      redirectUri: `${window.location.origin}/auth/google/callback`
    };
    return HttpService.post(`${API.googleLogin}`, enhancedPayload, config);
  }
  static async appleSignInWithToken(payload) {
    return HttpService.post(`${API.appleLogin}`, payload, config);
  }
  static async testUserLogin(payload) {
    await this.getToken();
    return HttpService.post(API.testUserLogin, payload, config);
  }
  static async addUsersToStream(payload) {
    await this.getToken();
    return HttpService.post(API.addUsersToStream, payload, config);
  }
  static async INVITE_COLLABORATOR(payload) {
    await this.getToken();
    return HttpService.post(`${API.INVITE_COLLABORATOR}`, payload, config);
  }
  static async INVITE_ROYALTIES(payload) {
    await this.getToken();
    return HttpService.post(`${API.INVITE_ROYALTIES}`, payload, config);
  }

  static async FUNDINGLINK(body, token) {
    await this.getToken(token);
    return HttpService.post(API.FUNDLINK, body, config);
  }

  static async PAYPALLINK(body, token) {
    await this.getToken(token);
    return HttpService.post(API.PAYPALLINK, body, config);
  }

  static async PAYPALLCAPTURE(payload) {
    await this.getToken();
    const query = serialize(payload);
    return HttpService.get(`${API.PAYPALLCAPTURE}` + query, config);
  }

  static async PAYPALLCANCEL(params) {
    await this.getToken();
    return HttpService.get(`${API.PAYPALLCANCEL}${params}`, config);
  }

  //user
  static async USER_DETAILS(payload) {
    await this.getToken();
    return HttpService.get(`${API.USER_DETAILS}` + payload, config);
  }
  static async FEATURE_USER(params) {
    await this.getToken();
    return HttpService.get(`${API.FEATURE_USER}${params}`, config);
  }
  static async FEATURE_ARTIST(params) {
    await this.getToken();
    return HttpService.get(`${API.FEATURE_ARTIST}${params}`, config);
  }

  static async SEARCH_USER(keyword) {
    await this.getToken();
    return HttpService.get(`${API.SEARCH_USER}` + keyword, config);
  }
  static async UPDATE_USER(payload) {
    await this.getToken();
    config.headers["Content-Type"] = "multipart/form-data";
    return HttpService.post(`${API.UPDATE_USER}`, payload, config);
  }
  static async PROFILE_UPDATE(payload) {
    await this.getToken();
    return HttpService.post(`${API.PROFILE_UPDATE}`, payload, config);
  }
  static async ADD_TOP_MUSIC(payload) {
    await this.getToken();
    return HttpService.post(`${API.ADD_TOP_MUSIC}`, payload, config);
  }
  static async USER_NFT_MUSIC(keyword) {
    await this.getToken();
    const query = serialize(keyword);
    return HttpService.get(`${API.USER_NFT_MUSIC}` + query, config);
  }
  static async USER_NFT_PLAYLIST(keyword) {
    await this.getToken();
    const query = serialize(keyword);
    return HttpService.get(`${API.USER_NFT_PLAYLIST}` + query, config);
  }
  static async USER_PROFILE(token) {
    await this.getToken(token);
    config.headers["Content-Type"] = "multipart/form-data";
    return HttpService.get(`${API.USER_PROFILE}`, config);
  }
  static async FLAG_USER(payload) {
    await this.getToken();
    return HttpService.post(`${API.FLAG_USER}`, payload, config);
  }
  static async ATTRIBUTES(token) {
    await this.getToken(token);

    return HttpService.get(`${API.ATTRIBUTES}`, config);
  }

  // Add this with your other API methods

static async SET_USER_TIMEZONE(timezone) {
  await this.getToken();
  return HttpService.post(`${API.SET_USER_TIMEZONE}`, { timezone }, config);
}

  //Subscription
  static async UPDATE_SUBSCRIPTION(payload) {
    await this.getToken();
    return HttpService.post(`${API.UPDATE_SUBSCRIPTION}`, payload, config);
  }
  static async GET_SUBSCRIPTIONS(params) {
    await this.getToken();
    return HttpService.get(`${API.GET_SUBSCRIPTIONS}` + params, config);
  }
  static async CREATE_SUBSCRIPTIONS(payload) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_SUBSCRIPTIONS}`, payload, config);
  }
  static async RENEWAL_SUBSCRIPTION_URL(params) {
    await this.getToken();
    return HttpService.post(
      `${API.RENEWAL_SUBSCRIPTION_URL}${params}`,
      { autoRenewal: params },
      config
    );
  }
  static async SUBSCRIBE_ARTIST(payload) {
    await this.getToken();
    return HttpService.post(`${API.SUBSCRIBE_ARTIST}`, payload, config);
  }
  static async UNSUBSCRIBE_ARTIST(payload) {
    await this.getToken();
    return HttpService.post(`${API.UNSUBSCRIBE_ARTIST}`, payload, config);
  }

  static async UNLOCKED_ASSETS(keywords) {
    await this.getToken();
    const query = serialize(keywords);
    return HttpService.get(`${API.UNLOCKED_ASSETS}` + query, config);
  }
  static async PRIVATE_ASSETS(id) {
    await this.getToken();
    return HttpService.get(`${API.PRIVATE_ASSETS}` + id, config);
  }

  //Music

  static async UPLOAD_MUSIC(payload) {
    await this.getToken();
    return HttpService.post(`${API.UPLOAD_MUSIC}`, payload, config);
  }

  static async MY_MUSIC(payload) {
    await this.getToken();
    return HttpService.get(`${API.MY_MUSIC}` + payload, config);
  }
  static async MUSIC_DETAIL(params) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_DETAIL}` + params, config);
  }

  static async FEATURE_MUSIC(payload) {
    await this.getToken();
    return HttpService.get(`${API.FEATURE_MUSIC}${payload}`, config);
  }
  static async SEARCH_MUSIC(keyword) {
    await this.getToken();
    return HttpService.get(`${API.SEARCH_MUSIC}` + keyword, config);
  }
  static async ALL_ARTIST_MUSIC(keywords) {
    const params = "?" + serialize(keywords);
    await this.getToken();
    return HttpService.get(`${API.ALL_ARTIST_MUSIC}` + params, config);
  }
  static async INDIVIDUAL_SONG_TIPPER(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.INDIVIDUAL_SONG_TIPPER}` + query, config);
  }

  //Album
  static async MY_ALBUM(body) {
    await this.getToken();
    return HttpService.get(`${API.MY_ALBUM}` + body, config);
  }
  static async CREATE_ALBUM(body) {
    await this.getToken();
    config.headers["Content-Type"] = "multipart/form-data";
    return HttpService.post(`${API.CREATE_ALBUM}`, body, config);
  }
  static async DELETE_ALBUM(params) {
    await this.getToken();
    return HttpService.get(`${API.DELETE_ALBUM}` + params, config);
  }
  static async ALBUM_DETAILS(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.ALBUM_DETAILS}` + query, config);
  }

  static async EDIT_ALBUM(body, params) {
    await this.getToken();
    config.headers["Content-Type"] = "multipart/form-data";
    return HttpService.post(`${API.EDIT_ALBUM}${params}`, body, config);
  }
  static async ADD_SONGS_TO_ALBUM(payload) {
    await this.getToken();
    return HttpService.post(`${API.ADD_SONGS_TO_ALBUM}`, payload, config);
  }
  static async DELETE_SONG_FROM_ALBUM(payload) {
    await this.getToken();
    return HttpService.post(`${API.DELETE_SONG_FROM_ALBUM}`, payload, config);
  }
    static async PLAYLIST(params, isParams) {
      await this.getToken();
      if (isParams) {
        const query = serialize(params);
        return HttpService.get(`${API.MY_PLAYLIST}?${query}`, config);
      } else {
        return HttpService.get(`${API.PLAYLIST}${params}`, config);
      }
    }
  static async PLAYLIST_DETAIL(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.PLAYLIST_DETAIL}` + query, config);
  }

  static async CREATE_PLAYLIST(params) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_PLAYLIST}`, params, config);
  }
  static async EDIT_PLAYLIST(id, body) {
    await this.getToken();
    config.headers["Content-Type"] = "multipart/form-data";
    return HttpService.post(
      `${API.EDIT_PLAYLIST}?playlistId=${id}`,
      body,
      config
    );
  }

  static async DELETE_PLAYLIST(params) {
    await this.getToken();
    return HttpService.get(`${API.DELETE_PLAYLIST}` + params, config);
  }

  static async FEATURE_PLAYLIST(params) {
    await this.getToken();
    return HttpService.get(`${API.FEATURE_PLAYLIST}${params}`, config);
  }
  static async SEARCH_PLAYLIST(keyword) {
    await this.getToken();
    return HttpService.get(`${API.SEARCH_PLAYLIST}` + keyword, config);
  }
  static async ASSET_PRIVACY(payload) {
    await this.getToken();
    return HttpService.post(`${API.ASSET_PRIVACY}`, payload, config);
  }
  static async ADD_SONG_TO_PLAYLIST(payload) {
    await this.getToken();
    return HttpService.post(`${API.ADD_SONG_TO_PLAYLIST}`, payload, config);
  }
  static async REMOVE_SONG_FROM_PLAYLIST(payload) {
    await this.getToken();
    return HttpService.post(
      `${API.REMOVE_SONG_FROM_PLAYLIST}`,
      payload,
      config
    );
  }
  static async SAVE_PLAYLIST(payload) {
    await this.getToken();
    return HttpService.post(`${API.SAVE_PLAYLIST}`, payload, config);
  }
  static async GET_PLAYLIST_MUSIC(payload) {
    await this.getToken();
    return HttpService.get(`${API.GET_PLAYLIST_MUSIC}` + payload, config);
  }
  static async PLAYLIST_ALL_(payload) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_ALL_}` + payload, config);
  }
  static async SORT_PLAYLIST_MUSIC(payload) {
    await this.getToken();
    return HttpService.post(`${API.SORT_PLAYLIST_MUSIC}`, payload, config);
  }
  static async TOPTEN_MY_PLAYLIST(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.TOPTEN_MY_PLAYLIST}` + query, config);
  }
  static async TOPTEN_BUY_ME_PLAYLIST(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.TOPTEN_BUY_ME_PLAYLIST}` + query, config);
  }

static async GET_SAVES(type = null) {
  await this.getToken();
  const url = type ? `${API.SAVES}/${type}` : API.SAVES;
  console.log('GET_SAVES - Full URL:', url);
  console.log('GET_SAVES - API.SAVES:', API.SAVES);
  console.log('GET_SAVES - config:', config);
  return HttpService.get(url, config);
}

  static async ADD_SAVE(type, payload) {
    await this.getToken();
    return HttpService.post(`${API.SAVES}/${type}`, payload, config);
  }

static async REMOVE_SAVE(type, payload) {
  await this.getToken();
  // For DELETE requests, data goes in config.data
  return HttpService.delete(`${API.SAVES}/${type}`, {
    ...config,
    data: payload
  });
}

  //GENRE
  static async GENRE_LIST() {
    await this.getToken();
    return HttpService.get(`${API.GENRE_LIST}`, config);
  }

  //NFTs
  static async CREATE_PLAYLIST_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_PLAYLIST_NFT}`, body, config);
  }
  static async CREATE_PLAYLIST_NFT_V4(body) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_PLAYLIST_NFT_V4}`, body, config);
  }

  static async CREATE_MUSIC_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_MUSIC_NFT}`, body, config);
  }
  static async CREATE_MUSIC_NFT_V4(body) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_MUSIC_NFT_V4}`, body, config);
  }
  static async CREATE_MUSIC_NFT_V5(body) {
    await this.getToken();

    config.headers["Content-Type"] = "multipart/form-data";
    return HttpService.post(`${API.CREATE_MUSIC_NFT_V5}`, body, config);
  }
  static async MUSIC_NFT() {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_NFT}`, config);
  }
  static async PLAYLIST_NFT() {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_NFT}`, config);
  }
  static async NFT_BY_ID(params) {
    await this.getToken();
    return HttpService.get(`${API.NFT_BY_ID}` + params, config);
  }
  static async NFT_BY_ID_V2(params) {
    await this.getToken();
    return HttpService.get(`${API.NFT_BY_ID_V2}` + params, config);
  }
  static async PLAYLIST_NFT_BY_ID(params) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_NFT_BY_ID}` + params, config);
  }

  static async BID_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.BID_NFT}`, body, config);
  }
  static async BID_NFT_V2(body) {
    await this.getToken();
    return HttpService.post(`${API.BID_NFT_V2}`, body, config);
  }
  static async BUY_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.BUY_NFT}`, body, config);
  }
  static async BUY_NFT_V2(body) {
    await this.getToken();
    return HttpService.post(`${API.BUY_NFT_V2}`, body, config);
  }
  static async BUY_MUSIC_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.BUY_MUSIC_NFT}`, body, config);
  }
  static async SELL_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.SELL_NFT}`, body, config);
  }
  static async SELL_NFT_V2(body) {
    await this.getToken();
    return HttpService.post(`${API.SELL_NFT_V2}`, body, config);
  }
  static async AUCTION_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.AUCTION_NFT}`, body, config);
  }
  static async AUCTION_NFT_V2(body) {
    await this.getToken();
    return HttpService.post(`${API.AUCTION_NFT_V2}`, body, config);
  }
  static async NFT_OFFERS(params) {
    await this.getToken();
    return HttpService.get(`${API.NFT_OFFERS}` + params, config);
  }
  static async CANCEL_SELL(body) {
    await this.getToken();
    return HttpService.post(`${API.CANCEL_SELL}`, body, config);
  }
  static async CANCEL_SELL_V2(body) {
    await this.getToken();
    return HttpService.post(`${API.CANCEL_SELL_V2}`, body, config);
  }
  static async CANCEL_AUCTION_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.CANCEL_AUCTION_NFT}`, body, config);
  }
  static async CANCEL_AUCTION_NFT_V2(body) {
    await this.getToken();
    return HttpService.post(`${API.CANCEL_AUCTION_NFT_V2}`, body, config);
  }

  //AI 

  static async AI_ASK(question) {
  await this.getToken();
  return HttpService.post(API.AI_ASK, { question }, config);
}


  // AI Memory methods
  static async AI_GET_MEMORIES(options = {}) {
    await this.getToken();
    const query = options ? `?${serialize(options)}` : '';
    return HttpService.get(`${API.AI_MEMORY_LIST}${query}`, config);
  }

  static async AI_SEARCH_MEMORIES(query, options = {}) {
    await this.getToken();
    return HttpService.post(API.AI_MEMORY_SEARCH, { 
      query,
      limit: options.limit || 5,
      ...options
    }, config);
  }

  static async AI_ADD_MEMORY(content, metadata = {}) {
    await this.getToken();
    return HttpService.post(API.AI_MEMORY_ADD, { content, metadata }, config);
  }

  static async AI_DELETE_MEMORY(memoryId) {
    await this.getToken();
    // Replace :id placeholder with the actual memoryId
    const endpoint = API.AI_MEMORY_DELETE.replace(':id', memoryId);
    return HttpService.delete(endpoint, config);
  }

  static async AI_RESET_MEMORIES() {
    await this.getToken();
    return HttpService.delete(API.AI_MEMORY_RESET, config);
  }
  
static async AI_ENHANCED_ASK(question, context = {}) {
  await this.getToken();

  // First retrieve relevant memories and add them to context
  if (context.useMemory !== false) {
    try {
      const memories = await this.AI_SEARCH_MEMORIES(question, { limit: 3 });
      context.memories = memories.data?.results || [];
    } catch (error) {
      console.error('Error retrieving memories:', error);
    }
  }

  // Make the enhanced request with context - USE THE CORRECT ENDPOINT
  const res = await HttpService.post(API.AI_ENHANCED_ASK, {  // Changed from API.AI_ASK
    question, 
    context
  }, config);

  console.log('AI_ENHANCED_ASK raw res:', res);
  if (!res || !res.answer) {
    console.error('Invalid response from AI_ENHANCED_ASK:', res);
    return { answer: "I'm unable to respond right now. Please try again later." };
  }
  
  return res;
}

static async CREATE_CALENDAR_EVENT(payload) {
  await this.getToken();
  return HttpService.post(API.CREATE_CALENDAR_EVENT, payload, config);
}

// Add this with the other calendar methods

static async DELETE_CALENDAR_EVENT(eventId) {
  await this.getToken();
  // Make sure to properly replace the :id parameter
  const endpoint = API.DELETE_CALENDAR_EVENT.replace(':id', eventId);
  console.log('Delete endpoint:', endpoint); // Add this for debugging
  return HttpService.delete(endpoint, config);
}

static async FETCH_CALENDAR_EVENTS(userId) {
  await this.getToken();
  const query = `?userId=${userId}`;
  return HttpService.get(`${API.FETCH_CALENDAR_EVENTS}${query}`, config);
}

static async GET_TASKS(userId) {
  await this.getToken();
  return HttpService.get(`${API.GET_TASKS}?userId=${userId}`, config);
}

  //GET_NFT_FRACTIONS
  static async GET_NFT_FRACTIONS(params) {
    await this.getToken();
    return HttpService.get(`${API.GET_NFT_FRACTIONS}` + params, config);
  }
  GIFT_NFT_FRACTIONS; //
  static async GIFT_NFT_FRACTIONS(body) {
    await this.getToken();
    return HttpService.post(`${API.GIFT_NFT_FRACTIONS}`, body, config);
  }
  // gift playlist nft
  static async GIFT_PLAYLIST_NFT(body) {
    await this.getToken();
    return HttpService.post(`${API.GIFT_PLAYLIST_NFT}`, body, config);
  }
  //GET all
  static async ALL_NFT(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.ALL_NFT}` + query, config);
  }
  //FOLLOW
  static async FOLLOWERLIST(params) {
    await this.getToken();
    return HttpService.get(`${API.FOLLOWERLIST}` + params, config);
  }
  static async FOLLOWINGLIST(params) {
    await this.getToken();
    return HttpService.get(`${API.FOLLOWINGLIST}` + params, config);
  }
  static async UNFOLLOW(body) {
    await this.getToken();
    return HttpService.post(`${API.UNFOLLOW}`, body, config);
  }
  static async FOLLOW(body) {
    await this.getToken();
    return HttpService.post(`${API.FOLLOW}`, body, config);
  }
  //NOTIFICATIONS
  static async NOTIFICATIONS(params) {
    await this.getToken();
    return HttpService.get(`${API.NOTIFICATIONS}` + params, config);
  }
  static async MARK_SEEN(payload) {
    await this.getToken();
    const query = serialize(payload);
    return HttpService.put(`${API.MARK_SEEN}${query}`, {}, config);
  }
  static async MARK_ALL_SEEN(payload) {
    await this.getToken();
    return HttpService.put(`${API.MARK_ALL_SEEN}`, payload, config);
  }
  static async UNREAD() {
    await this.getToken();
    return HttpService.get(`${API.UNREAD}`, config);
  }

  //WALLET
  static async BALANCE() {
    await this.getToken();
    return HttpService.get(`${API.BALANCE}`, config);
  }
  static async TRANSACTIONS(keyword) {
    await this.getToken();
    const query = serialize(keyword);
    return HttpService.get(`${API.TRANSACTIONS}${query}`, config);
  }
  static async TOKEN_LIMIT_REQUEST(payload) {
    await this.getToken();
    return HttpService.post(`${API.TOKEN_LIMIT_REQUEST}`, payload, config);
  }

  //Offboard
  static async OFFBOARD_TRANSFER(body) {
    await this.getToken();
    return HttpService.post(`${API.OFFBOARD_TRANSFER}`, body, config);
  }

  static async OFFBOARD_CASHOUT(body) {
    await this.getToken();
    return HttpService.post(`${API.OFFBOARD_CASHOUT}`, body, config);
  }

  static async OFFBOARD_CASHOUT_LIST(body) {
    await this.getToken();
    return HttpService.post(`${API.OFFBOARD_CASHOUT_LIST}`, body, config);
  }

  static async OFFBOARD_CASHOUT_SEND(body) {
    await this.getToken();
    return HttpService.post(`${API.OFFBOARD_CASHOUT_SEND}`, body, config);
  }

  //Payment
  static async TIP_ARTIST(body) {
    await this.getToken();
    return HttpService.post(`${API.TIP_ARTIST}`, body, config);
  }
  static async TIP_PLAYLIST(body) {
    await this.getToken();
    return HttpService.post(`${API.TIP_PLAYLIST}`, body, config);
  }
  // GAMIFICATION;
  static async CURATOR_DATA(params) {
    await this.getToken();
    return HttpService.get(`${API.CURATOR_DATA}${params}`, config);
  }
  static async CREATOR_DATA(params) {
    await this.getToken();
    return HttpService.get(`${API.CREATOR_DATA}${params}`, config);
  }
  static async GLOBAL_LEADERBOARD(params) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.GLOBAL_LEADERBOARD}?${queryString}`, config);
  }

  // OPTIMIZED GAMIFICATION V2 - 5-10x FASTER
  static async GAMIFICATION_COMPLETE(userid) {
    await this.getToken();
    const queryString = userid ? `?userid=${userid}` : '';
    return HttpService.get(`${API.GAMIFICATION_COMPLETE}${queryString}`, config);
  }
  
  static async GAMIFICATION_CURATOR_V2(userid) {
    await this.getToken();
    const queryString = userid ? `?userid=${userid}` : '';
    return HttpService.get(`${API.GAMIFICATION_CURATOR_V2}${queryString}`, config);
  }
  
  static async GAMIFICATION_CREATOR_V2(userid) {
    await this.getToken();
    const queryString = userid ? `?userid=${userid}` : '';
    return HttpService.get(`${API.GAMIFICATION_CREATOR_V2}${queryString}`, config);
  }
  
  static async GLOBAL_LEADERBOARD_V2(params) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.GLOBAL_LEADERBOARD_V2}?${queryString}`, config);
  }
  
  static async LEADERBOARD_POSITION(userid, sortBy = 'totalPoints') {
    await this.getToken();
    const queryString = new URLSearchParams({ userid, sortBy }).toString();
    return HttpService.get(`${API.LEADERBOARD_POSITION}?${queryString}`, config);
  }
  static async TOPTEN_LISTEN_PLAYLIST() {
    await this.getToken();
    return HttpService.get(`${API.TOPTEN_LISTEN_PLAYLIST}`, config);
  }
  static async TOPTEN_TIP_PLAYLIST() {
    await this.getToken();
    return HttpService.get(`${API.TOPTEN_TIP_PLAYLIST}`, config);
  }
  static async TOPTEN_SAVED_PLAYLIST() {
    await this.getToken();
    return HttpService.get(`${API.TOPTEN_SAVED_PLAYLIST}`, config);
  }
  static async PLAYLIST_STATICS(keyword) {
    await this.getToken();
    const query = serialize(keyword);
    return HttpService.get(`${API.PLAYLIST_STATICS}` + query, config);
  }

  // Feed
static async FETCH_MUSIC_FEED(params = "") {
  await this.getToken();
  const query = params ? `?${serialize(params)}` : "";
  return HttpService.get(`${API.FEED_MUSIC}${query}`, config);
}

static async FETCH_VIDEO_FEED(params = "") {
  await this.getToken();
  const query = params ? `?${serialize(params)}` : "";
  return HttpService.get(`${API.FEED_VIDEO}${query}`, config);
}

  
  //Analytics
  static async MUSIC_ANALYTICS() {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_ANALYTICS}`, config);
  }
  static async LIFEIME_VIEW_ANALYTICS(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFEIME_VIEW_ANALYTICS}${range}`, config);
  }
  static async LIFETIME_TIP_ANALYTICS(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_TIP_ANALYTICS}${range}`, config);
  }
  static async LIFEIME_STREAM_ANALYTICS(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFEIME_STREAM_ANALYTICS}${range}`, config);
  }
  static async LIFEIME_FOLLOWERS_ANALYTICS(range) {
    await this.getToken();
    return HttpService.get(
      `${API.LIFEIME_FOLLOWERS_ANALYTICS}${range}`,
      config
    );
  }
  static async MUSIC_VIEW_ANALYTICS(params) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_VIEW_ANALYTICS}${params}`, config);
  }
  static async MUSIC_TIP_ANALYTICS(params) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_TIP_ANALYTICS}${params}`, config);
  }
  static async MUSIC_STREAM_ANALYTICS(params) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_STREAM_ANALYTICS}${params}`, config);
  }
  static async MUSIC_FOLLOW_ANALYTICS(params) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_FOLLOW_ANALYTICS}${params}`, config);
  }
  static async AGE_GROUP(params) {
    await this.getToken();
    return HttpService.get(`${API.AGE_GROUP}${params}`, config);
  }
  static async COUNT(params) {
    await this.getToken();
    return HttpService.get(`${API.COUNT}${params}`, config);
  }

  //curator
  static async LIFETIME_TIPS(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_TIPS}${range}`, config);
  }
  static async LIFETIME_LISTEN(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_LISTEN}${range}`, config);
  }
  static async LIFETIME_SUBSCRIPTION(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_SUBSCRIPTION}${range}`, config);
  }
  static async LIFETIME_OWNED(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_OWNED}${range}`, config);
  }
  static async LIFETIME_PURCHASE(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_PURCHASE}${range}`, config);
  }
  static async LIFETIME_PLAYLISTS(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_PLAYLISTS}${range}`, config);
  }
  static async LIFETIME_STREAMS(range) {
    await this.getToken();
    return HttpService.get(`${API.LIFETIME_STREAMS}${range}`, config);
  }
  static async CURATOR_TAB_DATA(range) {
    await this.getToken();
    return HttpService.get(`${API.CURATOR_TAB_DATA}${range}`, config);
  }
  //CREATOR
  static async CREATOR_STREAMS(range) {
    await this.getToken();
    return HttpService.get(`${API.CREATOR_STREAMS}${range}`, config);
  }
  static async SONG_RELEASED(range) {
    await this.getToken();
    return HttpService.get(`${API.SONG_RELEASED}${range}`, config);
  }
  static async NFT_SOLD(range) {
    await this.getToken();
    return HttpService.get(`${API.NFT_SOLD}${range}`, config);
  }
  static async PLAYLIST_ADD(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_ADD}${range}`, config);
  }
  static async CREATOR_TAB_DATA(range) {
    await this.getToken();
    return HttpService.get(`${API.CREATOR_TAB_DATA}${range}`, config);
  }
  //HomeScreen

  //MUSIC
  static async MUSIC_ALL(range) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_ALL}`, config);
  }
  static async MUSIC_MOST_LISTEN(range) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_MOST_LISTEN}`, config);
  }
  static async MUSIC_MOST_STREAM_TODAY(range) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_MOST_STREAM_TODAY}`, config);
  }
  static async MUSIC_MOST_STREAM_WEEK(range) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_MOST_STREAM_WEEK}`, config);
  }
  static async MUSIC_NEW_RELEASE(range) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_NEW_RELEASE}`, config);
  }
  static async MUSIC_MOST_TIPPED(range) {
    await this.getToken();
    return HttpService.get(`${API.MUSIC_MOST_TIPPED}`, config);
  }

  //NFT
  static async NFT_ALL(range) {
    await this.getToken();
    return HttpService.get(`${API.NFT_ALL}`, config);
  }
  static async MOSTEXPENSIVE(range) {
    await this.getToken();
    return HttpService.get(`${API.MOSTEXPENSIVE}`, config);
  }
  static async PLAYLISTMOSTEXPENSIVE(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLISTMOSTEXPENSIVE}`, config);
  }
  static async LEASTEXPENSIVE(range) {
    await this.getToken();
    return HttpService.get(`${API.LEASTEXPENSIVE}`, config);
  }
  static async PLAYLISTLEASTEXPENSIVE(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLISTLEASTEXPENSIVE}`, config);
  }
  static async OWNERPERCENTAGE(range) {
    await this.getToken();
    return HttpService.get(`${API.OWNERPERCENTAGE}`, config);
  }
  static async ENDINGSOONAUCTION(range) {
    await this.getToken();
    return HttpService.get(`${API.ENDINGSOONAUCTION}`, config);
  }
  static async NFT_RANK(param) {
    await this.getToken();
    return HttpService.get(`${API.NFT_RANK}${param}`, config);
  }
  static async ACTIVE_BID(param) {
    await this.getToken();
    return HttpService.get(`${API.ACTIVE_BID}${param}`, config);
  }
  //PLAYLIST
  static async PLAYLIST_ALL(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_ALL}`, config);
  }
  static async PLAYLIST_MOST_TIPPED(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_MOST_TIPPED}`, config);
  }
  static async PLAYLIST_STREAMED(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_STREAMED}`, config);
  }
  static async PLAYLIST_NEW_RELEASE(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_NEW_RELEASE}`, config);
  }
  static async PLAYLIST_STREAMED_LASTWEEK(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_STREAMED_LASTWEEK}`, config);
  }
  static async PLAYLIST_MOST_STREAMED(range) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_MOST_STREAMED}`, config);
  }
  //STREAM
  static async STREAM_ADD(payload) {
    await this.getToken();
    return HttpService.post(`${API.STREAM_ADD}`, payload, config);
  }

  //Public
  static async CHARGES() {
    await this.getToken();
    return HttpService.get(`${API.CHARGES}`, config);
  }
  //BANNER;
  static async BANNER() {
    await this.getToken();
    return HttpService.get(`${API.BANNER}`, config);
  }

  //Chat:
  static async GET_MESSAGES() {
    await this.getToken();
    return HttpService.get(`${API.GET_MESSAGES}`, config);
  }
  static async GET_PLAYLIST_TOP_FIVE(params) {
    await this.getToken();
    return HttpService.get(`${API.GET_PLAYLIST_TOP_FIVE}${params}`, config);
  }
  static async GET_PLAYLIST_MOST_TIPPED(params) {
    await this.getToken();
    return HttpService.get(`${API.PLAYLIST_TOP_MOST_TIPPED}${params}`, config);
  }
  static async GET_PLAYLIST_MOST_STREAMED(params) {
    await this.getToken();
    return HttpService.get(
      `${API.PLAYLIST_TOP_MOST_STREAMED}${params}`,
      config
    );
  }
  static async GET_TOP_CHATS(params) {
    await this.getToken();
    return HttpService.get(`${API.GET_TOP_CHATS}${params}`, config);
  }
  static async GET_PRIVATE_MESSAGE(params) {
    await this.getToken();
    const param = serialize(params);
    return HttpService.get(`${API.GET_PRIVATE_MESSAGE}${param}`, config);
  }
  static async READ_MESSAGE(params) {
    await this.getToken();
    const param = serialize(params);
    return HttpService.put(`${API.READ_MESSAGE}${param}`, {}, config);
  }

  static async GROUP_CHAT(params) {
    await this.getToken();

    return HttpService.get(`${API.GROUP_CHAT}${params}`, config);
  }
  static async GROUP_CHAT_V2(params) {
    await this.getToken();

    return HttpService.get(`${API.GROUP_CHAT_V2}${params}`, config);
  }

  static async GET_PLAYLIST_MESSAGE(params) {
    await this.getToken();
    const param = serialize(params);
    return HttpService.get(`${API.GET_PLAYLIST_MESSAGE}${param}`, config);
  }
  static async BLOCK_USER_CHAT(body) {
    await this.getToken();
    return HttpService.put(`${API.BLOCK_USER_CHAT}`, body, config);
  }
  static async BLOCKER_USER(params) {
    await this.getToken();
    return HttpService.get(`${API.BLOCKER_USER}${params}`, config);
  }
  static async GET_ROOM_ID(params) {
    await this.getToken();
    return HttpService.get(`${API.GET_ROOM_ID}${params}`, config);
  }

  //Auction House

  static async BID_LIST(params) {
    await this.getToken();
    return HttpService.get(`${API.BID_LIST}${params}`, config);
  }
  static async AUCTION_LIST(params) {
    await this.getToken();
    return HttpService.get(`${API.AUCTION_LIST}${params}`, config);
  }
  static async BID_AND_AUCTIONS() {
    await this.getToken();
    return HttpService.get(`${API.BID_AND_AUCTIONS}`, config);
  }
  static async OFFERS(param) {
    await this.getToken();
    return HttpService.get(`${API.OFFERS}${param}`, config);
  }
  static async ACTIVITY(param) {
    await this.getToken();
    return HttpService.get(`${API.ACTIVITY}${param}`, config);
  }
  static async OFFERS_PLAYLIST(param) {
    await this.getToken();
    return HttpService.get(`${API.OFFERS_PLAYLIST}${param}`, config);
  }
  static async ACTIVITY_PLAYLIST(param) {
    await this.getToken();
    return HttpService.get(`${API.ACTIVITY_PLAYLIST}${param}`, config);
  }

  //OFFERS
  static async OFFERS_SALE(param) {
    await this.getToken();
    return HttpService.get(`${API.OFFERS_SALE}${param}`, config);
  }
  static async OFFERS_AUCTION(param) {
    await this.getToken();
    return HttpService.get(`${API.OFFERS_AUCTION}${param}`, config);
  }

  //Streaming
  static async TOP_TIPPERS(param) {
    await this.getToken();
    return HttpService.get(`${API.TOP_TIPPERS}${param}`, config);
  }
  static async GOAL(param) {
    await this.getToken();
    return HttpService.get(`${API.GOAL}${param}`, config);
  }
  static async LIVESTREAM(param) {
    await this.getToken();
    return HttpService.get(`${API.LIVESTREAM}${param ? param : ""}`, config);
  }
 // Start a livestream
 static async LIVESTART(body) {
  await this.getToken();
  return HttpService.post(API.LIVESTART, body, config);
}

 // Start a livestream
 static async LIVEEXIT(body) {
  await this.getToken();
  return HttpService.post(API.LIVEEXIT, body, config);
}

// End a livestream
static async LIVEEND(body) {
  await this.getToken();
  return HttpService.post(API.LIVEEND, body, config);
}

// Join a livestream
static async LIVEJOIN(body) {
  await this.getToken();
  console.log("LIVEJOIN URL =>", API.LIVEJOIN);

  return HttpService.post(API.LIVEJOIN, body, config);
}

  static async LAYOUT(param) {
    await this.getToken();
    return HttpService.post(`${API.LAYOUT}${param}`, {}, config);
  }

  //MATIC

  static async CREATE_MATIC(param) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_MATIC}${param}`, {}, config);
  }

  //VIDEO

  static async FEATURE_VIDEO(params) {
    await this.getToken();
    // Use the dedicated featured videos endpoint
    return HttpService.get(`${API.FEATURE_VIDEO}?${params.replace('&', '')}`, config);
  }

  static async SEARCH_VIDEO(keyword) {
    await this.getToken();
    const params = serialize(keyword);
    return HttpService.get(`${API.VIDEO_SEARCH}?${params}`, config);
  }

  static async UPLOAD_VIDEO(payload) {
    await this.getToken();
    return HttpService.post(`${API.VIDEO}`, payload, config);
  }
  static async VIDEO_BY_UPLOADER(uploaderId) {
  await this.getToken();
  // Ensure uploaderId is provided
  if (!uploaderId) throw new Error("uploaderId is required");
  // Compose the full URL
  const url = `${API.VIDEO_BY_UPLOADER}${uploaderId}`;
  console.log("VIDEO_BY_UPLOADER URL:", url);
  return HttpService.get(url, config);
}

// Update video with studioId, videoId, and formData
static async UPDATEVIDEO({ studioId, videoId, formData }) {
  await this.getToken();
  
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: cookieStorage.getCookie("Authorization"),
    },
  };

  const updateUrl = `${API.UPDATEVIDEO.replace(':studioId', studioId).replace(':videoId', videoId)}`;
  return HttpService.put(updateUrl, formData, config);
}

// Delete video with studioId and videoId
static async deleteUserVideo(studioId, videoId) {
  await this.getToken();
  
  const config = {
    headers: {
      Authorization: cookieStorage.getCookie("Authorization"),
    },
  };

  const deleteUrl = `${API.DELETE_VIDEO.replace(':studioId', studioId).replace(':videoId', videoId)}`;
  return HttpService.delete(deleteUrl, config);
}

  

  static async VIDEO_USER(studioId) {
    await this.getToken();
    
    // Dynamically replace `:studioId` with the actual `studioId`
    const getvidUrl = `${API.VIDEO_USER.replace(':studioId', studioId)}`;
  
    // Fetch the videos
    return HttpService.get(getvidUrl, config);
  }
  

static async UPVID(studioId, formData) {
  await this.getToken(); 
  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: cookieStorage.getCookie("Authorization"),
    }
  };
  const uploadUrl = `${API.UPVID.replace(':studioId', studioId)}`;

  return HttpService.post(uploadUrl, formData, config);
}


static async deleteUserVideo(studioId, videoId) {
  await this.getToken(); 
  const config = {
 
    headers: {
      Authorization: cookieStorage.getCookie("Authorization"),
  }
};
  const deleteUrl = `${API.DELETE_VIDEO.replace(':studioId', studioId).replace(':videoId', videoId)}`;
  return HttpService.delete(deleteUrl, config);
}



  static async GET_VIDEOS(params) {
    await this.getToken();
    return HttpService.get(`${API.VIDEO}${params}`, config);
  }
  static async D_VIDEOS(params) {
    await this.getToken();
    return HttpService.get(`${API.DOWNLOAD_RECORDING}${params}`, config);
  }

  //Recordings
  static async RECORDINGS(params) {
    await this.getToken();
    return HttpService.get(`${API.RECORDINGS}${params}`, config);
  }

  static async deleteRecording(recordingId) {
    await this.getToken();
  
    const deleteUrl = `${API.DELETE_RECORDING.replace(':recordingId', recordingId)}`;
    console.log("Delete Recording URL:", deleteUrl);
  
    return HttpService.delete(deleteUrl, config);
  }
// ApiService.js

static async updateRecording(recordingId, formData) {
  await this.getToken();

  // Check if `recordingId` is provided
  if (!recordingId) {
    throw new Error("Recording ID is missing for update.");
  }

  const config = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: cookieStorage.getCookie("Authorization"),
    },
  };

  // Replace `:recordingId` with the actual recording ID
  const updateUrl = `${API.UPDATE_RECORDING.replace(':recordingId', recordingId)}`;
  console.log("Update Recording URL:", updateUrl);

  // Make sure to use `FormData` for the request payload
  return HttpService.put(updateUrl, formData, config);
}


  //language
  static async LANGUAGE(params) {
    await this.getToken();
    return HttpService.get(`${API.LANGUAGE}${params}`, config);
  }
  //Update gift
  static async updatGiftStatus(payload) {
    await this.getToken();
    return HttpService.post(`${API.UPDATE_GIFT_STATUS}`, payload, config);
  }
  //Add count
  static async ADD_COUNT() {
    await this.getToken();
    return HttpService.get(`${API.ADD_COUNT}`, config);
  }
  //Add
  static async ADD(params) {
    await this.getToken();
    return HttpService.get(`${API.ADD}${params}`, config);
  }

  //Trending music
  static async TRENDING(params) {
    await this.getToken();
    return HttpService.get(`${API.TRENDING}${params}`, config);
  }

  static async TOP_ALBUM_MUSIC_STUDIO_LIST(keyword) {
    const start = performance.now();
    await this.getToken();
    const query = serialize(keyword);
    const result = await HttpService.get(`${API.TOP_LIST}` + query, config);
    console.log(`TOP_ALBUM_MUSIC_STUDIO_LIST API took ${performance.now() - start}ms`);
    return result;
  }

  static async MUSIC_LIST(keyword) {
    await this.getToken();
    const query = serialize(keyword);
    return HttpService.get(`${API.MUSIC_LIST}` + query, config);
  }

  // Artist Search
  static async SEARCH_ARTIST(keyword) {
    await this.getToken();
    return HttpService.get(`${API.SEARCH_ARTIST}` + keyword, config);
  }

  // Elastic Search
  static async SEARCH(keyword) {
    await this.getToken();
    return HttpService.get(
      `${API.SEARCH}` + encodeURIComponent(keyword),
      config
    );
  }

  // schedule livestream
  static async SCHEDULE_LIVESTREAM(payload) {
    await this.getToken();
    return HttpService.post(`${API.SCHEDULE_LIVESTREAM}`, payload, config);
  }

  // schedule livestream cancel
  static async SCHEDULE_LIVESTREAM_CANCEL(keyword) {
    await this.getToken();
    return HttpService.post(`${API.SCHEDULE_LIVESTREAM_CANCEL}`, payload, config);
  }

  // schedule livestreams
  static async SCHEDULE_LIVESTREAMS(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.SCHEDULE_LIVESTREAMS}` + query, config);
  }

  // schedule livestreams date
  static async SCHEDULE_LIVESTREAMS_DATE(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.SCHEDULE_LIVESTREAMS_DATE}` + query, config);
  }

  // schedule livestreams user
  static async SCHEDULE_LIVESTREAMS_USER(params) {
    await this.getToken();
    const query = serialize(params);
    return HttpService.get(`${API.SCHEDULE_LIVESTREAMS_USER}` + query, config);
  }

  // Dynamic Link
  static async CREATE_DYNAMIC_LINK(payload) {
    await this.getToken();
    return HttpService.post(`${API.CREATE_DYNAMIC_LINK}`, payload, config);
  }

  // Banner Management
  static async GET_MEDIA_BANNERS() {
    await this.getToken();
    return HttpService.get(API.BANNER, config);
  }

  static async UPLOAD_BANNER(formData) {
    await this.getToken();
    const uploadConfig = {
      ...config,
      headers: {
        ...config.headers,
        'Content-Type': 'multipart/form-data',
      },
    };
    return HttpService.post(API.ADMIN_UPLOAD_BANNER, formData, uploadConfig);
  }

  static async DELETE_BANNERS(payload) {
    await this.getToken();
    const deleteConfig = {
      ...config,
      data: payload // For DELETE requests with body
    };
    return HttpService.delete(API.ADMIN_DELETE_BANNERS, deleteConfig);
  }

  static async TOGGLE_BANNER_VISIBILITY(payload) {
    await this.getToken();
    return HttpService.patch(API.ADMIN_TOGGLE_BANNER_VISIBILITY, payload, config);
  }

  static async GET_MLC_REPORT(params) {
    await this.getToken();
    const query = serialize(params);
    // Need to handle CSV response
    const csvConfig = {
      ...config,
      responseType: 'text'
    };
    return HttpService.get(`${SERVER_URL}/admin/mlc?${query}`, csvConfig);
  }

  // Generic HTTP methods
  static async get(url, params = {}) {
    await this.getToken();
    const query = Object.keys(params).length ? serialize(params) : '';
    const fullUrl = url.startsWith('/') ? `${SERVER_URL}${url}` : url;
    return HttpService.get(`${fullUrl}${query}`, config);
  }

  static async post(url, payload) {
    await this.getToken();
    const fullUrl = url.startsWith('/') ? `${SERVER_URL}${url}` : url;
    return HttpService.post(fullUrl, payload, config);
  }

  static async put(url, payload) {
    await this.getToken();
    const fullUrl = url.startsWith('/') ? `${SERVER_URL}${url}` : url;
    return HttpService.put(fullUrl, payload, config);
  }

  static async delete(url) {
    await this.getToken();
    const fullUrl = url.startsWith('/') ? `${SERVER_URL}${url}` : url;
    return HttpService.delete(fullUrl, config);
  }
  
  // Admin Balance Management
  static async getAllBalances(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.ADMIN_GET_ALL_BALANCES}?${queryString}`, config);
  }
  
  static async getUserBalanceDetails(userId) {
    await this.getToken();
    return HttpService.get(`${API.ADMIN_GET_USER_BALANCE_DETAILS}/${userId}`, config);
  }
  
  static async modifyUserBalance(userId, data) {
    await this.getToken();
    return HttpService.post(`${API.ADMIN_MODIFY_USER_BALANCE}/${userId}/modify`, data, config);
  }
  
  static async releaseLock(userId, lockId) {
    await this.getToken();
    return HttpService.post(`${API.ADMIN_RELEASE_LOCK}/${userId}/release-lock`, { lockId }, config);
  }
  
  static async reconcileBalance(userId) {
    await this.getToken();
    return HttpService.post(`${API.ADMIN_RECONCILE_BALANCE}/${userId}/reconcile`, {}, config);
  }
  
  // Token Transfer Methods
  static async transferTokens(data) {
    await this.getToken();
    return HttpService.post(`${API.ADMIN_TRANSFER_TOKENS}`, data, config);
  }
  
  static async transferToExternalWallet(data) {
    await this.getToken();
    return HttpService.post(`${API.ADMIN_TRANSFER_EXTERNAL}`, data, config);
  }
  
  static async getTransferHistory(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.ADMIN_TRANSFER_HISTORY}?${queryString}`, config);
  }
  
  static async getAvailableWallets(params = {}) {
    await this.getToken();
    const queryString = new URLSearchParams(params).toString();
    return HttpService.get(`${API.ADMIN_AVAILABLE_WALLETS}?${queryString}`, config);
  }

  // Song Request APIs
  static async SONG_REQUEST_SUBMIT(data) {
    await this.getToken();
    return HttpService.post(`${API.SONG_REQUEST_SUBMIT}`, data, config);
  }

  static async SONG_REQUEST_LIST(roomId) {
    await this.getToken();
    return HttpService.get(`${API.SONG_REQUEST_LIST}/${roomId}`, config);
  }

  static async SONG_REQUEST_ACCEPT(requestId) {
    await this.getToken();
    return HttpService.post(`${API.SONG_REQUEST_ACCEPT}/${requestId}`, {}, config);
  }

  static async SONG_REQUEST_REJECT(requestId) {
    await this.getToken();
    return HttpService.post(`${API.SONG_REQUEST_REJECT}/${requestId}`, {}, config);
  }

  static async SONG_REQUEST_CLEAR(roomId) {
    await this.getToken();
    return HttpService.delete(`${API.SONG_REQUEST_CLEAR}/${roomId}`, config);
  }

  static async SONG_REQUEST_ACCEPTED_LIST(roomId) {
    await this.getToken();
    return HttpService.get(`${API.SONG_REQUEST_ACCEPTED_LIST}/${roomId}`, config);
  }

  static async SONG_REQUEST_MARK_PLAYED(requestId) {
    await this.getToken();
    return HttpService.post(`${API.SONG_REQUEST_MARK_PLAYED}/${requestId}`, {}, config);
  }

  // Feedback Hub API methods
  static async FEEDBACK_CREATE(payload) {
    await this.getToken();
    return HttpService.post(`${SERVER_URL}/feedback`, payload, config);
  }

  static async FEEDBACK_GET_ALL() {
    await this.getToken();
    return HttpService.get(`${SERVER_URL}/feedback`, config);
  }

  static async FEEDBACK_DELETE(feedbackId) {
    await this.getToken();
    return HttpService.delete(`${SERVER_URL}/feedback/${feedbackId}`, config);
  }

  static async FEEDBACK_UPDATE_STATUS(feedbackId, status) {
    await this.getToken();
    return HttpService.put(`${SERVER_URL}/feedback/${feedbackId}/status`, { status }, config);
  }

  static async FEEDBACK_VOTE(feedbackId, type) {
    await this.getToken();
    return HttpService.post(`${SERVER_URL}/feedback/${feedbackId}/vote`, { type }, config);
  }
}
